import { Routes, Route } from 'react-router-dom';

import "./styles/global.css"

import KakaoRedirect from './pages/KakaoRedirect.jsx'
import Home from './pages/Home.jsx'
import Progress from './pages/Progress.jsx'

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<KakaoRedirect/>}/>
        <Route path="/home" element={<Home/>}/>
        <Route path="/progress" element={<Progress/>}/>
      </Routes>
    </div>
  );
}

export default App;
